function GuardianVO(id, firstName, lastName, gender, identityDocumentNumber, identityDocumentType, address, citizenship, pesel, phone, email, authorizedPersonType, type) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.gender = gender;
    this.identityDocumentNumber = identityDocumentNumber;
    this.identityDocumentType = identityDocumentType;
    this.address = address;
    this.citizenship = citizenship;
    this.pesel = pesel;
    this.phone = phone;
    this.email = email;
    this.authorizedPersonType = authorizedPersonType;

    this.type = type;


    var _typeContext = {
        address : AddressVO,
        citizenship : DictionaryElementVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
